import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=0a375d61&scoped=true"
import script from "./ProductCenter.vue?vue&type=script&lang=js"
export * from "./ProductCenter.vue?vue&type=script&lang=js"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=0a375d61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a375d61",
  null
  
)

export default component.exports